import React from 'react';
import styled from 'styled-components';
import {Button} from 'antd';

type EmailPreviewHeaderProps = {
  onCopyEmail: () => void;
  onSavePDF: () => void;
};

export const EmailPreviewHeader: React.FC<EmailPreviewHeaderProps> = ({onCopyEmail, onSavePDF}) => {
  return (
    <HeaderContainer>
      <Title>Email Preview Only</Title>
      <ButtonsContainer>
        <StyledButton onClick={onCopyEmail}>Copy Email</StyledButton>
        <StyledButton onClick={onSavePDF}>Save PDF</StyledButton>
      </ButtonsContainer>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 16px;
`;

const Title = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledButton = styled(Button)`
  border-radius: 4px;
  font-size: 14px;
  height: 32px;
  padding: 0 16px;
`;
